import Phone from "./SVG/phone.svg?react";

const PhoneIcon = () => {
  return <Phone />;
};

export default PhoneIcon;
